import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/services/helpers/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiResourcesV1 } from './helpers/api-resources';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private http: ApiService) {}

  getUsers(data: any): Observable<any> {
    return this.http.get(apiResourcesV1.users, data).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  getUser(id): Observable<any> {
    return this.http.get(`${apiResourcesV1.users}/${id}`).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  approve(id: number): Observable<any> {
    return this.http.put(`${apiResourcesV1.users}/${id}/approve`, {}).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  activate(id: number): Observable<any> {
    return this.http.post(`${apiResourcesV1.users}/${id}/reactivate`, {}).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  deleteUser(id): Observable<any> {
    return this.http.delete(`${apiResourcesV1.users}/${id}`).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  addUser(data): Observable<any> {
    return this.http.post(apiResourcesV1.users, data).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  updateUser(id, data): Observable<any> {
    return this.http.put(`${apiResourcesV1.users}/${id}`, data).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  batch(data): Observable<any> {
    return this.http.post(apiResourcesV1.batch, data).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  batchDelete(userIds: number[]): Observable<any> {
    return this.http
      .post(apiResourcesV1.batchDelete, { user_ids: userIds })
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  batchInvite(userIds: number[]): Observable<any> {
    return this.http
      .post(apiResourcesV1.batchInvite, { user_ids: userIds })
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  batchReactivate(userIds: number[]): Observable<any> {
    return this.http
      .post(apiResourcesV1.batchReactivate, { user_ids: userIds })
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  batchBan(userIds: number[]): Observable<any> {
    return this.http.post(apiResourcesV1.batchBan, { user_ids: userIds }).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  batchUnban(userIds: number[]): Observable<any> {
    return this.http
      .post(apiResourcesV1.batchUnban, { user_ids: userIds })
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  sendRegistrationInvite(id): Observable<any> {
    return this.http.put(apiResourcesV1.users + '/' + id + '/invite', {}).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  getProfile() {
    return this.http.get(apiResourcesV1.profile).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  updateProfile(data) {
    return this.http.put(`${apiResourcesV1.profile}`, data).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  changePassword(data) {
    return this.http
      .put(`${apiResourcesV1.profile}/change_password`, data)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  toggle2FA(data): Observable<any> {
    return this.http
      .post(apiResourcesV1.users + '/toggle_two_factor_auth', data)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  sendGuide(users: number[], sessionId: number = null): Observable<any> {
    return this.http
      .post(apiResourcesV1.users + '/send_guide', {
        user_ids: users,
        session_id: sessionId,
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  exportUsers(data: any = {}): Observable<Blob> {
    return this.http.get(
      `${apiResourcesV1.users}/export`,
      data,
      'blob',
    ) as Observable<Blob>;
  }
}
